import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { MainAppComponent } from '../../../layout/layout.component';

@Component({
  selector: 'rolelist',
  templateUrl: './rolelist.component.html',
  styleUrls: ['./rolelist.component.scss']
})

export class RoleList implements OnInit {

  mainComponent: any;
  roles = [];
  constructor(public _router: Router,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _mApp: MainAppComponent, private _toastrService: ToastrService) {
    this.mainComponent = _mApp;
  }

  ngOnInit() {
    this.GetRoles();
  }

  GetRoles() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetRolesList)
      .subscribe(
      data => {
        this._mApp.HideLoader();
        this.roles = data.json().Result;
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

}